/* eslint-disable arrow-body-style */
import React from 'react';

import { Button, Link, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import InviteStudentsContainer from './InviteStudentsContainer';
import { InviteErrorBody } from './types/inviteStudentsTypes';
import { CONTACT_SUPPORT } from '../../constants/urls';
import error400 from '../../images/400.svg';
import error403 from '../../images/403.svg';
import error500 from '../../images/500.svg';

const StyledButtonContainer = styled.div`
    text-align: left;
    margin-top: 10px;
`;

const StyledErrorContainer = styled.div`
    text-align: center;
`;

const StyledCancelButton = withStyles(() => ({
    root: {
        margin: '10px'
    }
}))(Button);

const StyledErrorMessage = withStyles(() => ({
    root: {
        textAlign: 'center'
    }
}))(Typography);

const errorImageMap = {
    400: error400,
    403: error403,
    500: error500
};

const SubmitError: React.FunctionComponent = () => {
    const { t } = useTranslation(['invite_students', 'admin_settings', 'error_messages']);
    const { inviteStudentsResult, returnToRosterUrl } = useContainer(InviteStudentsContainer);
    const handleCancelClick = () => {
        // TODO - ought to be history.push but when in demo mode URL isn't a react path.
        window.location.href = returnToRosterUrl;
    };

    const renderCancelButton = () => {
        return (
            <StyledButtonContainer>
                <StyledCancelButton color="secondary" variant="contained" onClick={handleCancelClick}>
                    {t('components.cancel')}
                </StyledCancelButton>
            </StyledButtonContainer>
        );
    };

    const errorResopnseBody = inviteStudentsResult.body as InviteErrorBody;

    const statusCode = inviteStudentsResult.status || 500;
    const errorMessage = errorResopnseBody.error || t('error_messages:http-500.submissions-error');
    const errorData = errorResopnseBody.data ? JSON.stringify(errorResopnseBody.data) : '';

    if (statusCode === 403) {
        return (
            <StyledErrorContainer>
                <img src={errorImageMap[statusCode]}></img>
                <StyledErrorMessage variant="h4">{t('admin_settings:unauthorized.noPermission')}</StyledErrorMessage>
                <StyledErrorMessage variant="h5">
                    {t('admin_settings:unauthorized.contactAdministrator')}
                </StyledErrorMessage>
                {renderCancelButton()}
            </StyledErrorContainer>
        );
    }

    return (
        <StyledErrorContainer>
            <StyledErrorMessage variant="h4">{t('error_messages:have-a-problem')}</StyledErrorMessage>
            <img src={errorImageMap[statusCode]}></img>
            <StyledErrorMessage variant="h4">
                <Link href={CONTACT_SUPPORT} target="_blank">
                    {t('error_messages:contact-support')}
                </Link>
            </StyledErrorMessage>
            <StyledErrorMessage variant="h5">{errorMessage ?? ''}</StyledErrorMessage>
            <StyledErrorMessage variant="h5">{errorData ?? ''}</StyledErrorMessage>
            {renderCancelButton()}
        </StyledErrorContainer>
    );
};

export default SubmitError;
